import { render, staticRenderFns } from "./Lgx279924608939851776.vue?vue&type=template&id=ac0642c4&"
import script from "./Lgx279924608939851776.vue?vue&type=script&lang=js&"
export * from "./Lgx279924608939851776.vue?vue&type=script&lang=js&"
import style0 from "./Lgx279924608939851776.vue?vue&type=style&index=0&id=ac0642c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports